import { X, Link as LinkIcon } from "lucide-react";
import { Button } from "@/shared/ui/button";
import { Label } from "@/shared/ui/label";
import {
  ReceivableTaxDocument,
  PendingReceivableTaxDocument,
} from "../../utils/types";
import { getTaxDocumentTypeLabel } from "./utils";

interface TaxDocumentListProps {
  documents: (ReceivableTaxDocument | PendingReceivableTaxDocument)[];
  onRemove: (document: ReceivableTaxDocument | PendingReceivableTaxDocument) => void;
  disabled?: boolean;
  title?: string;
}

export function TaxDocumentList({
  documents,
  onRemove,
  disabled = false,
  title,
}: TaxDocumentListProps) {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      {title && (
        <Label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {title} ({documents.length})
        </Label>
      )}
      <ul className="space-y-2 rounded-md border border-white/10 bg-background/40 p-3">
        {documents.map((document) => (
          <li
            key={document.id}
            className="flex items-start justify-between gap-2 rounded-md bg-black/10 p-3"
          >
            <div className="flex-1 min-w-0 space-y-1">
              <div className="flex items-center gap-2">
                <span className="font-medium text-sm text-foreground">
                  {getTaxDocumentTypeLabel(document.documentType)}
                </span>
              </div>
              {document.description && (
                <p className="text-xs text-muted-foreground">{document.description}</p>
              )}
              {document.file && !("documentUrl" in document && document.documentUrl) && (
                <p className="truncate text-xs text-muted-foreground">{document.file.name}</p>
              )}
              {"documentUrl" in document && document.documentUrl && (
                <a
                  href={document.documentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-xs text-primary hover:underline"
                  onClick={(e) => e.stopPropagation()}
                >
                  <LinkIcon className="h-3 w-3" /> Abrir comprovante
                </a>
              )}
            </div>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-8 w-8 text-destructive hover:text-destructive shrink-0"
              onClick={() => onRemove(document)}
              disabled={disabled}
            >
              <X className="h-4 w-4" />
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}

